import * as React from "react"
import * as CheckboxPrimitive from "@radix-ui/react-checkbox"
import { Check } from "lucide-react"

import { cn } from "@/lib/utils"

const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      // 🔴 UI-FLOOR-1 (s208) — LEFT AT 16px, for the reason written out in `switch.tsx`.
      //
      // A 44px ::after hit area on a 16px box overlaps its neighbours even harder than the switch
      // does, and checkboxes sit in the densest lists in the app. The floor needs row pitch, not a
      // component edit. 🔴 This one does NOT yet clear WCAG 2.5.8 (24×24) either — it is the
      // smallest control in the product and it is the one place the floor genuinely bites.
      // Reported, not forced, because the fix is a spacing decision on every hosting surface.
      "peer h-4 w-4 shrink-0 rounded-sm border border-primary ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground",
      className
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator
      className={cn("flex items-center justify-center text-current")}
    >
      <Check className="h-4 w-4" />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
))
Checkbox.displayName = CheckboxPrimitive.Root.displayName

export { Checkbox }
